import { render, staticRenderFns } from "./AttendanceGeneralSettings.vue?vue&type=template&id=25932071"
import script from "./AttendanceGeneralSettings.vue?vue&type=script&lang=js"
export * from "./AttendanceGeneralSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports